import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";

const ZypleRadio = withStyles({
  root: {
    color: "#6A5FF5",
    padding: 0,
    margin: 0,
    "&$checked": {
      color: "#6A5FF5",
    },
  },
  checked: {},
})((props) => <Radio disableRipple color="default" {...props} />);

export default ZypleRadio;
